(function($) {
	if ($('html').length > 0) {
		var lan = $('html').attr('lang'); // .split('_')[0];
	}

	function updateCart() {
		let url = (lan === 'fr') ? '/?sections=cart' : `/${lan}/?sections=cart`;
		console.log(url);

		$.ajax({
			url: url,
			type: 'GET',
			dataType: 'html',
			beforeSend: function () {
				$('.cart-wrapper').addClass('loading');
			},
			complete: function () {
				$('.cart-wrapper').removeClass('loading');
			},
			success: function(data) {
				data = JSON.parse(data);
				$('.cart-page-container').html(data.cart);
				$('.header-wrapper-last-cart-wrp').html(data.cart);
				jQuery.getJSON('/cart.js', function(cart) {
					$('.header-wrapper-last-cart-counter').text(cart.item_count);
				});
			}
		})

	}

	$('.header-wrapper-last-cart-wrp').on('click', '.cart-wrapper-item-remove', function() {
		let item = $(this).parents('.cart-wrapper-item');
		$.ajax({
			url: `${$(this).attr('req')}`,
			method: 'GET',
			success:function() {
				$(item).hide(300, function() {
					$(item).remove();
					updateCart();
				});
			}
		})
	})

	$('.header-wrapper-last-cart-wrp').on('click', '.cart-heading-close', function() {
		$('body').find('.header-wrapper-last-cart > svg').trigger('click');
	});

	$('.cart-page-container').on('click', '.cart-wrapper-item-remove', function() {
		let item = $(this).parents('.cart-wrapper-item');
		$.ajax({
			url: `${$(this).attr('req')}`,
			method: 'GET',
			success:function() {
				$(item).hide(300, function() {
					$(item).remove();
					updateCart();
				});
			}
		})
	})

	$('.header-wrapper-last-cart-wrp').on('click', '.cart-wrapper-item-desc-quantity > span', function() {
		let c = parseInt($(this).attr('val'));
		let quantity = parseInt($(this).parent().find('input').val()) + c;

		let variant = parseInt($(this).parent().attr('variant'));
		if (quantity >= 1) {
			$(this).parent().find('input').val(quantity);
			$(this).parents('.cart-wrapper-item-desc').find('.cart-wrapper-item-desc-price > span').text(quantity);

			$.ajax({
				url: '/cart/change.js',
				method: 'POST',
				data: {
					quantity: quantity,
					id: variant
				},
				success: function() {
					updateCart();
				}
			})
		}
	})

	$('.cart-page-container').on('click', '.cart-wrapper-item-desc-quantity > span', function() {
		let c = parseInt($(this).attr('val'));
		let quantity = parseInt($(this).parent().find('input').val()) + c;

		let variant = parseInt($(this).parent().attr('variant'));
		console.log(variant, quantity, c);
		if (quantity >= 1) {
			$(this).parent().find('input').val(quantity);
			$(this).parents('.cart-wrapper-item-desc').find('.cart-wrapper-item-desc-price > span').text(quantity);

			$.ajax({
				url: '/cart/change.js',
				method: 'POST',
				data: {
					quantity: quantity,
					id: variant
				},
				success: function() {
					updateCart();
				}
			})
		}
	})

	$('.header-wrapper-last-cart > svg').click(function() {
		updateCart();
		$('.header-wrapper-last-cart-wrp').slideToggle(300);
		$('.header-wrapper-last-cart-wrp').toggleClass('active');
		if ($(window).width() <= 768) {
			$('body').toggleClass('cart');
			$('.header-wrapper-main ul').hide(300);
			$('.header-wrapper-last-toggle').removeClass('active');
		}
	})

	if ($('.cart-continue').length > 0) {
		let lan = $('html').attr('lang');
		let url = (lan === 'fr') ? '/collections' : `/${lan}/collections`;
		$('.cart-continue').attr('href', url);
	}

})(jQuery);